var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { HttpParams } from '@angular/common/http';
var defaultSortParam = 'codi';
var defaultSortDirection = 'asc';
var TipusTiquetsFilterService = /** @class */ (function (_super) {
    __extends(TipusTiquetsFilterService, _super);
    function TipusTiquetsFilterService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TipusTiquetsFilterService.prototype.createFilterParams = function (filter, start, pageSize, sortField, sortDir) {
        return new HttpParams()
            .append('codi', filter.codi === null ? '' : filter.codi.toString())
            .append('descripcio', filter.descripcio)
            .append('dataInici', filter.dataInici === null ? '' : filter.dataInici.toString())
            .append('dataFi', filter.dataFi === null ? '' : filter.dataFi.toString())
            .append('start', start.toString())
            .append('size', pageSize.toString())
            .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
            .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
    };
    return TipusTiquetsFilterService;
}(CustomFilterService));
export { TipusTiquetsFilterService };
